import React, { createContext, useState, useContext } from "react";
import { ConfirmModal } from "../common/ConfirmModal";
import { NotificationModal } from "../common/NotificationModal";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    isOpen: false,
    type: "success",
    message: "",
    closeText: "Close",
  });
  const [confirm, setConfirm] = useState({
    isOpen: false,
    message: "",
    onConfirm: null,
    confirmButtonText: "Delete", // Default for confirmation button
    cancelButtonText: "Cancel", // Default for cancel button
  });

  const showNotification = (type, message, closeText = "Close") => {
    setNotification({ isOpen: true, type, message, closeText });
  };

  const closeNotification = () => {
    setNotification({ isOpen: false, type: "success", message: "", closeText: "Close" });
  };

  const showConfirm = (
    message,
    onConfirm,
    confirmButtonText = "Delete",
    cancelButtonText = "Cancel"
  ) => {
    setConfirm({
      isOpen: true,
      message,
      onConfirm,
      confirmButtonText,
      cancelButtonText,
    });
  };

  const closeConfirm = () => {
    setConfirm({
      isOpen: false,
      message: "",
      onConfirm: null,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    });
  };

  const handleConfirm = () => {
    if (confirm.onConfirm) confirm.onConfirm();
    closeConfirm();
  };

  return (
    <NotificationContext.Provider
      value={{ showNotification, closeNotification, showConfirm, closeConfirm }}
    >
      {children}
      <NotificationModal
        isOpen={notification.isOpen}
        onClose={closeNotification}
        type={notification.type}
        message={notification.message}
        closeText={notification.closeText}
      />
      <ConfirmModal
        isOpen={confirm.isOpen}
        onClose={closeConfirm}
        onConfirm={handleConfirm}
        message={confirm.message}
        confirmButtonText={confirm.confirmButtonText}
        cancelButtonText={confirm.cancelButtonText}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
